<script setup lang="ts">
defineProps<{
  forceSlash?: boolean
  curr: number | string | None
  max: number | string | None
  maxPrice?: boolean
  red: boolean
}>()

function toPrice(i: number | string) {
  return typeof i === 'number' ? helpers.priceFormat(i) : i
}
</script>

<template>
  <span :class="$style.c">
    <em v-if="helpers.isDef(curr)" class="_mono _c1 _fw-xxl">{{ curr }}</em>
    <span v-if="forceSlash || helpers.isDef(curr)" :class="[$style.s, curr && 'm_mr1']" />
    <b v-if="max && maxPrice" :class="red && '_red'" class="_mono">{{ toPrice(max) }}</b>
    <span v-else class="_mono _fw-xxl">{{ max }}</span>
  </span>
</template>

<style module>
.c {
  composes: global(_ls-xs);
  composes: global(_fs09);
  composes: global(_row);
  composes: global(_inline);
  composes: global(_ctrY);
  composes: global(_lh1);
  cursor: default;
}
.s {
  composes: global(_relative);
  background: currentColor;
  width: 1px;
  margin: 0 4px 3px 8px;
  height: 10px;
  top: 1px;
  transform: skewX(-20deg);
  flex: 0 0 1px;
}
</style>
